





















import { defineComponent } from "@vue/composition-api";
import BaseButton from "@/components/BaseButton/BaseButton.vue";
import BaseIcon from "@/components/BaseIcon";

export default defineComponent({
  name: "StepperButtons",
  components: { BaseIcon, BaseButton },
  props: {
    hasNext: { type: Boolean, default: false },
    hasPrev: { type: Boolean, default: false },
    saving: { type: Boolean, default: false },
  },
});
